import { render, staticRenderFns } from "./ChangePasswordForm.vue?vue&type=template&id=3fa150e9&scoped=true&"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa150e9",
  null
  
)

export default component.exports